import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'

// import styles
import './linkdrafts.scss'

// Actions
import { getOrderSimple, bookOrder, saveOrder } from '../../../../actions/orders'

// import components
import Modal from '../../../components/Modal'

// Utils
import { getStepName } from '../../../../utils/order'
import { translation } from '../../../../utils/helpers'

// Elements
import Radio from '../../../elements/radio'
import LabelWrapper from '../../../elements/labelWrapper'
import Inline from '../../../elements/inline'
// import Icon from '../../../elements/icon'
import PanelHeader from '../../../elements/panelHeader'

import { ModalIcons } from '../../../elements/icons'

class LinkDraftsModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      overflowHidden: false,
      mainOrder: null,
      draft: null,
      hasTransport: false,
      chosenTransport: 0,
      booking: false
    }

    this.bookDraft = this.bookDraft.bind(this)
  }

  componentDidMount () {
    const { getOrderSimple, mainOrderId, draftId } = this.props

    Promise.all([getOrderSimple(mainOrderId), getOrderSimple(draftId)])
      .then(res => {
        const orders = res.map(r => r.data)

        this.setState({
          mainOrder: orders[0],
          draft: orders[1],
          hasTransport: !!orders[1].Transport
        })
      })
  }

  bookDraft () {
    const { draft, mainOrder, hasTransport } = this.state

    const book = () => {
      this.props.bookOrder({
        OrderId: draft.Id
      }).then(res => {
        this.props.complete()
      }).catch(err => {
        let errorText = []
        if (err.response && err.response.data && err.response.data.Errors) {
          const { Errors } = err.response.data
          errorText = Errors.map(e => e.DictionaryKey && `<br />${translation(e.DictionaryKey)}<br />`)
          // Toastr
          window.toastr.error(errorText.join(), translation('216'))
        } else {
          // Toastr
          window.toastr.error(translation('13417'), translation('216'))
        }

        this.setState({
          booking: false
        })
      })
    }

    this.setState({
      booking: true
    }, () => {
      if (!hasTransport) {
        const isBodyShop = mainOrder.IsBodyShopOrder

        var data = {
          OrderId: draft.Id,
          [isBodyShop ? 'BodyShopDelivery' : 'Delivery']: {
            IsDirty: true,
            Delivery: isBodyShop ? mainOrder.BodyShopDeliveryTime : mainOrder.Delivery,
            ProductionDate: isBodyShop ? mainOrder.BodyShopProductionTime : mainOrder.ProductionDate,
            Pickup: isBodyShop ? mainOrder.BodyShopPickupTime : mainOrder.Pickup,
            Transport: this.state.chosenTransport
          }
        }

        if (isBodyShop) {
          data.Delivery = {
            IsDirty: true,
            Delivery: mainOrder.Delivery,
            ProductionDate: mainOrder.ProductionDate,
            Pickup: mainOrder.Pickup,
            Transport: mainOrder.Transport
          }
        }

        this.props.saveOrder(data)
        .then(book)
        .catch(() => {
          this.setState({
            booking: false
          })
          // Toastr
          window.toastr.error(translation('960'), translation('216'))
        })
      } else {
        book()
      }
    })
  }

  renderView () {
    const { draft, mainOrder } = this.state

    const loadingSpinner = () => {
      return (
        <div className='linkdraft-loading'>
          <div className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <span className='sr-only'>{translation('13382')}...</span>
          </div>
        </div>
      )
    }
    if (!draft || !mainOrder) return loadingSpinner()

    const formatDate = (dateStr) => {
      return moment(dateStr).format('DD-MM-YYYY – hh:mm')
    }

    const renderDraft = () => {
      const { Pickup, BodyShopPickupTime, ProductionDate, BodyShopProductionTime, Delivery, BodyShopDeliveryTime } = draft
      const isBodyShop = draft.IsBodyShopOrder

      return (
        <LabelWrapper key={0} labelText={translation('14722') + ':'}>
          <Inline block fillChildNum={[0]} key={1}>
            <span className='linkdraft__title'>{translation('14948')}: </span>
            <span className='linkdraft__date'>{formatDate(isBodyShop ? BodyShopPickupTime : Pickup)}</span>
          </Inline>
          <Inline block fillChildNum={[0]} key={2}>
            <span className='linkdraft__title'>{translation('13394')}: </span>
            <span className='linkdraft__date'>{formatDate(isBodyShop ? BodyShopProductionTime : ProductionDate)}</span>
          </Inline>
          <Inline block fillChildNum={[0]} key={3}>
            <span className='linkdraft__title'>{translation('14724')}: </span>
            <span className='linkdraft__date'>{formatDate(isBodyShop ? BodyShopDeliveryTime : Delivery)}</span>
          </Inline>
        </LabelWrapper>
      )
    }

    const renderMain = () => {
      const { StepId, Pickup, BodyShopPickupTime, ProductionDate, BodyShopProductionTime, Delivery, BodyShopDeliveryTime } = mainOrder
      const isBodyShop = mainOrder.IsBodyShopOrder

      return (
        <LabelWrapper key={0} labelText={translation('14725') + ':'}>
          <Inline block fillChildNum={[0]} key={1}>
            <span className='linkdraft__title'>{translation('946')}: </span>
            <span className='linkdraft__date'>{translation(getStepName(StepId))}</span>
          </Inline>
          <Inline block fillChildNum={[0]} key={2}>
            <span className='linkdraft__title'>{translation('14948')}: </span>
            <span className='linkdraft__date'>{formatDate(isBodyShop ? BodyShopPickupTime : Pickup)}</span>
          </Inline>
          <Inline block fillChildNum={[0]} key={3}>
            <span className='linkdraft__title'>{translation('13394')}: </span>
            <span className='linkdraft__date'>{formatDate(isBodyShop ? BodyShopProductionTime : ProductionDate)}</span>
          </Inline>
          <Inline block fillChildNum={[0]} key={4}>
            <span className='linkdraft__title'>{translation('14724')}: </span>
            <span className='linkdraft__date'>{formatDate(isBodyShop ? BodyShopDeliveryTime : Delivery)}</span>
          </Inline>
        </LabelWrapper>
      )
    }

    const renderRadioList = () => {
      const name = 'Transport'
      let transportId = this.state.chosenTransport
      const listItems = this.props.transport

      // Transport formatter to add icons?
      // const formatter = ({ Id, Name }) => {
      //   let transportImage = 'can_drive16'
      //   if (Id === 3) { transportImage = 'transport16' }
      //   if (Id === 2) { transportImage = 'loose_part16' }

      //   return (
      //     <span className='linkdraft__img'>
      //       <span>{translation(Name)}</span>
      //       <img src={'/images/icons/' + transportImage + '.png'} />
      //     </span>
      //   )
      // }

      const onInputChange = ({ target: { value } }) => {
        this.setState({
          chosenTransport: value
        })
      }

      return (
        listItems.map((transportType, index) => {
          const id = `${name}_${transportType.Id}_input`
          // let label = (
          //   <Inline>
          //     {translation(transportType.Name)}
          //     <Icon icon={makeTransportIcon(transportType.Id)} />
          //   </Inline>
          // )
          return (
            <Radio key={index}
              labelText={translation(transportType.Name)}
              id={id}
              name={name}
              value={transportType.Id}
              onChange={onInputChange}
              checked={transportId.toString() === transportType.Id.toString() ? 'checked' : false} />
          )
        })
      )
    }
    // console.log('draft', this.state.draft, 'main', this.state.mainOrder, this.state.hasTransport)
    // 'Transport', 6, 6, 1, 6, transportFormatter, 'list', this.props.transport, ['Id', 'Name'])
    // value, draftCustomer, draftShop, bookedCustomer, bookedShop, formatter, type, listItems, listItemValName, translate
    console.log('this.state.hasTransport ', this.state.hasTransport)
    return (
      <div className='linkdraft'>
        <span>{translation('14952')}</span>
        <PanelHeader text={translation(13373)} />
        {renderDraft()}
        {renderMain()}

        {!this.state.hasTransport && (
          <LabelWrapper labelText={translation(13371)}>
            {renderRadioList()}
          </LabelWrapper>
        )}

        <div className='pg-mb-2'>{translation('14953')}</div>

        {this.state.booking && loadingSpinner()}
      </div>
    )
  }

  render () {
    return (
      <div>
        <Modal
          header={translation('1848')}
          overflowHidden={this.state.overflowHidden}
          onClose={this.props.onClose}
          clickOutsideClose={false}
          icon={ModalIcons.Link}
          show={this.props.show}
          bottomBarProps={{
            actionLabelText: translation(47),
            onActionClick: this.bookDraft,
            cancelLabelText: translation(48),
            onCancelClick: this.props.onClose
          }}
        >
          {this.renderView()}
        </Modal>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    transport: state.common.transport
  }
}

export default connect(mapStateToProps, {
  getOrderSimple,
  bookOrder,
  saveOrder
})(LinkDraftsModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/LinkOrdersModal/LinkDraftsModal/index.js